import React, { FC, useState } from 'react';

import { Outlet } from 'react-router-dom';

import { ProjectDirectoryLayout } from '@adsk/alloy-project-page-layout';
import { Box } from '@adsk/alloy-react-box';
import { RemoteComponent, TabTitle } from '@adsk/exo-skeleton-react';

import ProjectsHeader from './ProjectsHeader';
import AlloyContextSubscriber from '../../components/AlloyContextSubscriber';
import { ConnectedAnnouncementBanner } from '../../components/AnnouncementBanner/ConnectedAnnouncementBanner';
import AppContentError from '../../components/AppContentError/AppContentError';
import { AuthenticationListener } from '../../components/Authnentication/AuthenticationListener';
import { ContentLayoutLoader } from '../../components/FullPageLayoutLoader/ContentLayoutLoader';
import { IdleTimerAllAccountsListener } from '../../components/IdleTimer/listeners/IdleTimerAllAccountsListener';
import { useFeatureFlag } from '../../components/LaunchDarklyProvider';
import RemoteNetworkBuildersProfileModal from '../../components/RemoteNetworkApiComponents/RemoteNetworkBuildersProfileModal';
import RemoteNetworkOnboardingACCUserModal from '../../components/RemoteNetworkApiComponents/RemoteNetworkOnboardingACCUserModal';
import useFeatureFlagOnce2 from '../../hooks/useFeatureFlagOnce2';

const OutletContainer: FC = () => {
  return (
    <>
      <RemoteComponent
        scope="accProjectList"
        moduleName="./ProductLinks"
        renderLoader={() => <Box height={48} />}
      />
      <ProjectsHeader />
      <Outlet />
    </>
  );
};

const autoFetchEntitiesWithAccountEntitlements = [
  ProjectDirectoryLayout.AUTO_FETCH_TYPES.CURRENT_ACCOUNTS_ENTITLEMENTS,
];

const Projects = () => {
  const { value: useAccNetworkApiComponentsRemote } = useFeatureFlag<boolean>(
    'useAccNetworkApiComponentsRemote',
    false,
  );
  const { value: callAccountEntitlements } = useFeatureFlag<boolean>(
    'call-account-entitlements-in-pl',
    false,
  );
  const { value: enableIdleTimeFF } = useFeatureFlagOnce2('login-idle-time');

  const [isBuildersProfileModalEnabled, setIsBuildersProfileModalEnabled] =
    useState<boolean | undefined>(false);
  const [isBuildersProfileModalShown, setIsBuildersProfileModalShown] =
    useState(false);

  return (
    <ProjectDirectoryLayout
      renderAboveLayout={() => <ConnectedAnnouncementBanner />}
      autoFetchEntities={
        callAccountEntitlements ? autoFetchEntitiesWithAccountEntitlements : []
      }
      UNSAFE_showBuildersUserProfileModal={() => {
        setIsBuildersProfileModalShown(true);
      }}
      UNSAFE_isBuildersProfileModalEnabled={isBuildersProfileModalEnabled}
    >
      <TabTitle />
      <AuthenticationListener />
      {enableIdleTimeFF && <IdleTimerAllAccountsListener />}
      <RemoteComponent
        scope="accProjectList"
        moduleName="./ProvidersContainer"
        renderError={() => <AppContentError />}
        renderLoader={() => <ContentLayoutLoader />}
      >
        <AlloyContextSubscriber>
          <OutletContainer />
        </AlloyContextSubscriber>
      </RemoteComponent>
      {useAccNetworkApiComponentsRemote && (
        <>
          <RemoteNetworkOnboardingACCUserModal
            showModal={true}
            onSuccess={() => {
              setIsBuildersProfileModalEnabled(undefined);
            }}
          />
          <RemoteNetworkBuildersProfileModal
            setShowModal={setIsBuildersProfileModalShown}
            showModal={isBuildersProfileModalShown}
            isBuildersProfileModalEnabled={isBuildersProfileModalEnabled}
            setIsBuildersProfileModalEnabled={setIsBuildersProfileModalEnabled}
          />
        </>
      )}
    </ProjectDirectoryLayout>
  );
};

export default Projects;
